import { UrlParamToSubmittedTranslation } from "@/globalConsts/urlParamToSubmittedTranslation";
import type { Submitted } from "@/types/submitted";
import {
  COUNTRY_LEGACY,
  COUNTRY_PREFIX,
  LEGACY_DST_PARAM,
  FILTER,
  PAGE,
  PRICE,
  DURATION,
  TAGS,
} from "@/globalConsts/queryParams";
import { pushUrlSearchParams } from "@/lib/url/pushUrlSearchParams";

type SearchParam = {
  [k: string]: string;
};

function setSubmitted(params: SearchParam, itemsPerPage: number) {
  const submitted: { [index: string]: string | string[] | number } = {};

  Object.keys(params).forEach((paramKey) => {
    if (params[paramKey]) {
      const convertedParamKey = UrlParamToSubmittedTranslation[paramKey];

      if (convertedParamKey === undefined) {
        return;
      }

      if (paramKey === PRICE) {
        const priceArray = params.pr.split(",");
        submitted.minPrice = parseInt(priceArray[0]);
        submitted.maxPrice = parseInt(priceArray[1]);
      } else if (paramKey === DURATION) {
        const durationArray = params.du.split("-");
        submitted.minDuration = parseInt(durationArray[0]);
        submitted.maxDuration = parseInt(durationArray[1]);
      } else if (paramKey === FILTER) {
        submitted[convertedParamKey] = params[paramKey].split(",");
      } else if (paramKey === PAGE) {
        submitted[convertedParamKey] =
          itemsPerPage * (parseInt(params[PAGE]) - 1);
      } else {
        submitted[convertedParamKey] = params[paramKey];
      }
    }
  });

  return submitted;
}

function appendTags(destParam: string, tags: string | null): string {
  if (!tags) {
    return destParam;
  }

  return destParam.concat(",", tags);
}

/**
 * legacy search param "dst" needs to be rewritten
 * dst=cy_123 becomes ft=ct_123
 */
function rewriteDstParam(searchParams: URLSearchParams): URLSearchParams {
  if (searchParams.has(LEGACY_DST_PARAM)) {
    const tags = searchParams.get(TAGS);
    let destParam = searchParams.get(LEGACY_DST_PARAM) ?? "";

    destParam = destParam.replace(COUNTRY_LEGACY, COUNTRY_PREFIX);

    searchParams.set(TAGS, appendTags(destParam, tags));
    searchParams.delete(LEGACY_DST_PARAM);

    pushUrlSearchParams(Object.fromEntries(searchParams));
  }

  return searchParams;
}

function getSearchParams(): URLSearchParams {
  const searchParams = new URLSearchParams(location.search);

  return rewriteDstParam(searchParams);
}

export function createSubmittedFromUrl(
  itemsPerPage: number
):
  | { submittedValues: Submitted; currentPage: number; restore: boolean }
  | undefined {
  const params = Object.fromEntries(getSearchParams());
  let currentPage = 1;

  if (!params) {
    return;
  }

  const submittedValues = setSubmitted(params, itemsPerPage);

  if (params[PAGE]) {
    currentPage = parseInt(params[PAGE]);
  }
  const restore = Object.keys(params).includes("restore");

  return <
    { submittedValues: Submitted; currentPage: number; restore: boolean }
  >{
    submittedValues,
    currentPage,
    restore,
  };
}
